import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { OrphanPunch, AttachOrphanRequest } from '../interfaces/shift/OrphanPunch';

export const OrphanPunchService = {
    listUnresolved: async (institutionId: string): Promise<OrphanPunch[]> => {
        const r = await axios.get(ENDPOINTS.SHIFT.ORPHANS(institutionId));
        return r.data;
    },
    attach: async (institutionId: string, id: string, body: AttachOrphanRequest): Promise<{ attendanceId: string }> => {
        const r = await axios.post(ENDPOINTS.SHIFT.ORPHAN_ATTACH(institutionId, id), body);
        return r.data;
    },
    discard: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.SHIFT.ORPHAN_DELETE(institutionId, id));
    },
};
